import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import OsteopataContext from "../../context/osteopata";
import UserContext from "../../context/user";

const useOsteopathCancelMutation = (closeModal) => {
  const { callApi, userProfile } = useContext(UserContext);
  const { setCurrentRequest } = useContext(OsteopataContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ requestId }) =>
      callApi(`/osteopath/request/${requestId}/user-cancel-reservation`, {
        method: "DELETE",
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
        setCurrentRequest();
        closeModal();
      },
    }
  );
};

export default useOsteopathCancelMutation;
